import './session-sdo';
import {localStorageKeys, supportedLocales, supportedLocalesMap, sdoNs} from './constants-enumerate';
import {storeInstance} from '@aofl/store/dist/legacy';

let tempDefaultLang = localStorage.getItem(localStorageKeys.LANG);
if (tempDefaultLang === null) {
  let tempSelectedLang = navigator.language.substring(0, 2);
  if (supportedLocales.indexOf(navigator.language) >= 0) {
    tempDefaultLang = navigator.language;
  } else if (tempSelectedLang == 'zh') {
    tempDefaultLang = 'zh-CN';
  } else if (tempSelectedLang == 'ja') {
    tempDefaultLang = 'ja-JA';
  } else if (tempSelectedLang == 'es') {
    tempDefaultLang = 'es-US';
  }
  tempSelectedLang = undefined;
}
const defaultLang = tempDefaultLang;
tempDefaultLang = undefined;
if (defaultLang !== null && supportedLocales.indexOf(defaultLang) !== -1) {
  document.documentElement.setAttribute('lang', defaultLang);
  storeInstance.commit({
    namespace: sdoNs.SESSION,
    mutationId: 'setLocale',
    payload: defaultLang
  });
}

const observer = new MutationObserver((mutationList) => {
  const lang = mutationList[0].target.lang;
  if (supportedLocales.indexOf(lang) !== -1) return;
  const newLang = supportedLocalesMap[lang];
  if (typeof newLang !== 'undefined' && supportedLocales[newLang] !== -1) {
    document.documentElement.setAttribute('lang', newLang);
    storeInstance.commit({
      namespace: sdoNs.SESSION,
      mutationId: 'setLocale',
      payload: newLang
    });
  }
});

observer.observe(document.documentElement, {attributes: true});
